
const INITIAL_STATE = {
      drawerState: false,
      addEventState: false,
      hiddenState: {
        canidateList: false,
        canidateEventDetails: true,
        adminCanidateDetails: false,
        adminCanidateEventDetails: true,
      },
      navState: {
        landing: false,
        home: false,
        account: false,
        messagin: false,
        events: false,
        addEvent: false,
        canidate: false,
        adminHome: false,
        adminEvents: false,
        adminConnectedEvents: false,
        adminConfirmedEvents: false,
        canidateConfirmedList: false,
        adminUserMgm: false,
      }
      
  };
  
  const applyDrawerState = (state, action) => ({
    ...state,
    drawerState: action.value
  });

  const applyAddEventState = (state, action) => ({
    ...state,
    addEventState: action.value
  });

  const applyToggleView= (state, action) => {
    return({
      hiddenState: {
        ...state.hiddenState,
        [action.payload.component]: action.payload.hidden
      }

    })
  }

  const applyToggleNav = (state, action) => {
  
    const activeStyle = {...INITIAL_STATE.navState}
    activeStyle[action.payload]=true
    
    return ({
      ...state,
      navState: {...activeStyle}
    })
  }
  
  function appStateReducer(state = INITIAL_STATE, action) {
    switch(action.type) {

      case 'LOADING' : {
        return ({
          ...state,
          isLoading: action.value
        })
      }
      case 'TOGGLE_DRAWER' : {
        
        return applyDrawerState(state, action);
      }
      case 'TOGGLE_ADDEVENT' : {
       
        return applyAddEventState(state, action)
      }
      case 'TOGGLE_VIEW' : {
        return applyToggleView(state, action)
      }
      case 'TOGGLE_NAV' : {
        return applyToggleNav(state, action)
          
      }
      default : return state;
    }
  }
  
  export default appStateReducer;


// WEBPACK FOOTER //
// ./src/reducers/appState.js